<div class="main-container">
  <div *ngIf="!submitView"class="heading">Shifts List</div>

  <ion-col *ngIf="!submitView" size="12" class="selected-shift-count">
    <p>
      {{getSelectedShiftCount()}} shifts selected for deletion
    </p>
  </ion-col>


  <form *ngIf="editRecurrentSpecificShiftForm" [formGroup]="editRecurrentSpecificShiftForm">
    <app-edit-recurring-shift-list
    [confirmationView]="submitView"
    [formGroup]="editRecurrentSpecificShiftForm"
    (onToggleAllCheckBoxes)="onToggleAllCheckBoxes($event)" (onToggleCheckBox)="onToggleCheckBox($event)"
    [config]="config" [data]="data"
    ></app-edit-recurring-shift-list>
</form>

<ion-row>
  <ion-button
  *ngIf = "!submitView && shifts && shifts.length > 5 && skipItems <= shifts.length"
  class = "load-more" 
  (click) = "loadMoreData()">
  Load More</ion-button>
</ion-row>
<!-- <app-pagination class="flex-end" *ngIf = "shifts && shifts.length" pageSize="4" [totalRecords] = "shifts.length" (onPageChange) = "loadMoreData($event)"></app-pagination> -->
</div>